import React, { useState } from 'react';
import { useForm } from 'react-hook-form';
import { useGetActivitiesByIdQuery } from 'features/getActivities/api/getActivitiesApi';
import { useParams } from 'react-router-dom';
import { PromoStateType, ActivityDataСreateUpdateType } from 'entities/promo/types';
import { setDrawerOpen } from 'features/ui/model/uiSlice';
import { useUpdateActivityMutation } from 'features/createActivity/api/createActivityApi';
import { useDispatch } from 'react-redux';
import { useUpdatePromoCardDefaultValues } from 'entities/promo/lib/hooks/useUpdatePromoCardDefaultValues';
import PromoCard from './PromoCard';

export const UpdatePromoCard = () => {
  const { id } = useParams();
  const dispatch = useDispatch();

  const { data: activityList, refetch: refetchActivity } = useGetActivitiesByIdQuery({ id });
  const [updateActivityRequest] = useUpdateActivityMutation();

  const [state, setState] = useState<PromoStateType>({
    value: 0,
    formLang: '0',
    isSuccess: false,
    shopDotsOpen: false,
  });

  const updatePromoCardDefaultValues = useUpdatePromoCardDefaultValues(activityList);

  const { reset, handleSubmit, ...form } = useForm({ defaultValues: updatePromoCardDefaultValues });

  const onSubmit = (data: ActivityDataСreateUpdateType) => {
    const transformedData = {
      ...data,
      activity_type_id: data.activity_type_id,
    };

    updateActivityRequest({
      id: data.id,
      body: transformedData,
    }).then(() => {
      dispatch(setDrawerOpen(false));
      refetchActivity();
    });
  };

  return (
    <PromoCard
      state={state}
      setState={setState}
      form={form}
      onSubmit={handleSubmit(onSubmit)}
      textButton="Изменить"
    />
  );
};
